import React, {useState, useEffect} from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import '../styles/EnvironmentControl.css';

const EnvironmentControl = ({authTokens, showAlert, onActionComplete}) => {
    const applications = ["Premium", "Tentacle", "Adoption"];
    const environments = ["Development", "QA"];

    const [formData, setFormData] = useState({
        application: applications[0],
        environment: environments[0],
        endDate: new Date(),
        endTime: new Date(new Date().setHours(new Date().getHours() + 1))
    });
    // const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [stopLoading, setStopLoading] = useState(false);

    // Set default times when component mounts
    useEffect(() => {
        const today = new Date();

        // Set default time to current time + 1 hour
        const defaultEndTime = new Date();
        defaultEndTime.setHours(defaultEndTime.getHours() + 1);
        // Round to nearest 15 minutes
        defaultEndTime.setMinutes(Math.ceil(defaultEndTime.getMinutes() / 15) * 15);

        setFormData({
            ...formData,
            endDate: today,
            endTime: defaultEndTime
        });
    }, []);

    const handleChange = (name, value) => {
        if (name === 'endDate') {
            // If date changes, adjust time if needed
            const currentDate = new Date();
            const newDate = new Date(value);

            // Check if selected date is today
            const isToday = newDate.getDate() === currentDate.getDate() &&
                newDate.getMonth() === currentDate.getMonth() &&
                newDate.getFullYear() === currentDate.getFullYear();

            if (isToday) {
                // If selected time is in the past, set time to current time + 30 min (rounded to 15 min interval)
                const currentTime = formData.endTime;
                if (currentTime < new Date(currentDate.getTime() + 30 * 60000)) {
                    const adjustedTime = new Date();
                    adjustedTime.setMinutes(adjustedTime.getMinutes() + 30);
                    adjustedTime.setMinutes(Math.ceil(adjustedTime.getMinutes() / 15) * 15);
                    setFormData({
                        ...formData,
                        endDate: value,
                        endTime: adjustedTime
                    });
                    return;
                }
            }
        }

        setFormData({
            ...formData,
            [name]: value
        });
    };

    const formatDate = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formatTime = (time) => {
        if (!time) return '';
        const hours = String(time.getHours()).padStart(2, '0');
        const minutes = String(time.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const mapEnvironment = (env) => {
        return env === "Development" ? "dev" : "qa";
    };

    const mapApplication = (app) => {
        return app.toLowerCase();
    };

    // const handleSubmit = async (state) => {
    //     try {
    //         setIsSubmitting(true);
    //
    //         // Validate end time is at least 30 minutes in the future when starting environment
    //         if (state === 'start') {
    //             const now = new Date();
    //             const endDateTime = new Date(formData.endDate);
    //             endDateTime.setHours(formData.endTime.getHours());
    //             endDateTime.setMinutes(formData.endTime.getMinutes());
    //
    //             const timeDifference = endDateTime - now;
    //             const minutesDifference = timeDifference / (1000 * 60);
    //
    //             if (minutesDifference < 30) {
    //                 showAlert('error', 'End time must be at least 30 minutes from now.');
    //                 setIsSubmitting(false);
    //                 return;
    //             }
    //         }
    //
    //         const payload = {
    //             application: mapApplication(formData.application),
    //             environment: mapEnvironment(formData.environment),
    //             state: state,
    //             stop_date: formatDate(formData.endDate),
    //             stop_time: formatTime(formData.endTime)
    //         };
    //
    //         console.log('Sending payload:', payload);
    //         console.log('Using token:', authTokens.tokenType, authTokens.accessToken);
    //
    //         const response = await fetch('https://uquqfl7xad.execute-api.ap-southeast-2.amazonaws.com/prod/env-control', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `${authTokens.accessToken}`
    //             },
    //             body: JSON.stringify(payload)
    //         });
    //
    //         const data = await response.json();
    //         console.log('Response:', data);
    //
    //         if (data.statusCode === 200 || data.success === true) {
    //             showAlert('success', data.message || `Environment ${state === 'start' ? 'started' : 'stopped'} successfully`);
    //
    //             // Call onActionComplete to refresh environment status
    //             if (onActionComplete && typeof onActionComplete === 'function') {
    //                 // Adding a small delay to allow the backend to update
    //                 setTimeout(() => {
    //                     onActionComplete();
    //                 }, 500);
    //             }
    //         } else {
    //             showAlert('error', data.message || 'Operation failed');
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         showAlert('error', 'An error occurred while processing your request');
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };

    const handleSubmit = async (state) => {
      try {
        // Set the appropriate loading state
        if (state === 'start') {
          setSubmitLoading(true);
        } else {
          setStopLoading(true);
        }

        // Validate end time is at least 30 minutes in the future when starting environment
        if (state === 'start') {
          const now = new Date();
          const endDateTime = new Date(formData.endDate);
          endDateTime.setHours(formData.endTime.getHours());
          endDateTime.setMinutes(formData.endTime.getMinutes());

          const timeDifference = endDateTime - now;
          const minutesDifference = timeDifference / (1000 * 60);

          if (minutesDifference < 30) {
            showAlert('error', 'End time must be at least 30 minutes from now.');
            setSubmitLoading(false);
            return;
          }
        }


        const payload = {
          application: mapApplication(formData.application),
          environment: mapEnvironment(formData.environment),
          state: state,
          stop_date: formatDate(formData.endDate),
          stop_time: formatTime(formData.endTime)
        };

        console.log('Sending payload:', payload);
        console.log('Using token:', authTokens.tokenType, authTokens.accessToken);

        const response = await fetch('https://uquqfl7xad.execute-api.ap-southeast-2.amazonaws.com/prod/env-control', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${authTokens.tokenType} ${authTokens.accessToken}`
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json();
        console.log('Response:', data);

        if (data.statusCode === 200 || data.success === true) {
          showAlert('success', data.message || `Environment ${state === 'start' ? 'started' : 'stopped'} successfully`);

          // Call onActionComplete to refresh environment status
          setTimeout(() => {
            if (onActionComplete && typeof onActionComplete === 'function') {
              onActionComplete();
            }
          }, 1000);
        } else {
          showAlert('error', data.message || 'Operation failed');
        }
      } catch (error) {
        console.error('Error:', error);
        showAlert('error', 'An error occurred while processing your request');
      } finally {
        // Reset the appropriate loading state
        if (state === 'start') {
          setSubmitLoading(false);
        } else {
          setStopLoading(false);
        }
      }
    };

    // Add this function to format time in 12-hour format with AM/PM
    const formatTimeWithAMPM = (time) => {
        if (!time) return '';

        let hours = time.getHours();
        const minutes = String(time.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';

        // Convert from 24-hour to 12-hour format
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'

        return `${hours}:${minutes} ${ampm}`;
    };

    // Generate time options in 15-minute intervals with AM/PM format
    const generateTimeOptions = () => {
        const options = [];
        const now = new Date();
        const selectedDate = formData.endDate;

        // Check if selected date is today
        const isToday = selectedDate.getDate() === now.getDate() &&
            selectedDate.getMonth() === now.getMonth() &&
            selectedDate.getFullYear() === now.getFullYear();

        // Start hour and minute
        let startHour = 0;
        let startMinute = 0;

        // If today, start from current time + 30 minutes (rounded up to next 15 min interval)
        // if (isToday) {
        //     startHour = now.getHours();
        //     startMinute = now.getMinutes() + 30;
        //
        //     // Adjust for minute overflow
        //     if (startMinute >= 60) {
        //         startHour += Math.floor(startMinute / 60);
        //         startMinute = startMinute % 60;
        //     }
        //
        //     // Round up to next 15 minute interval
        //     startMinute = Math.ceil(startMinute / 15) * 15;
        //
        //     // Adjust for minute overflow after rounding
        //     if (startMinute >= 60) {
        //         startHour += Math.floor(startMinute / 60);
        //         startMinute = startMinute % 60;
        //     }
        // }

        // Generate time options
        for (let hour = startHour; hour < 24; hour++) {
            for (let minute = (hour === startHour ? Math.ceil(startMinute / 15) * 15 : 0); minute < 60; minute += 15) {
                const date = new Date();
                date.setHours(hour, minute, 0);
                options.push({
                    value: date,
                    label: formatTimeWithAMPM(date)
                });
            }
        }

        return options;
    };

    // // Generate time options in 15-minute intervals, considering selected date
    // const generateTimeOptions = () => {
    //   const options = [];
    //   const now = new Date();
    //   const selectedDate = formData.endDate;
    //
    //   // Check if selected date is today
    //   const isToday = selectedDate.getDate() === now.getDate() &&
    //                   selectedDate.getMonth() === now.getMonth() &&
    //                   selectedDate.getFullYear() === now.getFullYear();
    //
    //   // Start hour and minute
    //   let startHour = 0;
    //   let startMinute = 0;
    //
    //   // If today, start from current time + 30 minutes (rounded up to next 15 min interval)
    //   if (isToday) {
    //     startHour = now.getHours();
    //     startMinute = now.getMinutes() + 30;
    //
    //     // Adjust for minute overflow
    //     if (startMinute >= 60) {
    //       startHour += Math.floor(startMinute / 60);
    //       startMinute = startMinute % 60;
    //     }
    //
    //     // Round up to next 15 minute interval
    //     startMinute = Math.ceil(startMinute / 15) * 15;
    //
    //     // Adjust for minute overflow after rounding
    //     if (startMinute >= 60) {
    //       startHour += Math.floor(startMinute / 60);
    //       startMinute = startMinute % 60;
    //     }
    //   }
    //
    //   // Generate time options
    //   for (let hour = startHour; hour < 24; hour++) {
    //     for (let minute = (hour === startHour ? Math.ceil(startMinute / 15) * 15 : 0); minute < 60; minute += 15) {
    //       const hourString = hour.toString().padStart(2, '0');
    //       const minuteString = minute.toString().padStart(2, '0');
    //       options.push(`${hourString}:${minuteString}`);
    //     }
    //   }
    //
    //   return options;
    // };

    // Current time formatted for comparison
    const currentTimeString = formatTime(formData.endTime);
    const timeOptions = generateTimeOptions();

    return (
        <div className="environment-control">
            <div className="control-form">
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="application">Application</label>
                        {/*<select*/}
                        {/*    id="application"*/}
                        {/*    value={formData.application}*/}
                        {/*    onChange={(e) => handleChange('application', e.target.value)}*/}
                        {/*    className="form-control"*/}
                        {/*    disabled={isSubmitting}*/}
                        {/*>*/}
                        <select
                          id="application"
                          value={formData.application}
                          onChange={(e) => handleChange('application', e.target.value)}
                          className="form-control"
                          disabled={submitLoading || stopLoading}
                        >
                            {applications.map(app => (
                                <option key={app} value={app}>{app}</option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="environment">Environment</label>
                        <select
                            id="environment"
                            value={formData.environment}
                            onChange={(e) => handleChange('environment', e.target.value)}
                            className="form-control"
                            disabled={submitLoading || stopLoading}
                        >
                            {environments.map(env => (
                                <option key={env} value={env}>{env}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="endDate">Stop Date</label>
                        <DatePicker
                            id="endDate"
                            selected={formData.endDate}
                            onChange={(date) => handleChange('endDate', date)}
                            dateFormat="MM/dd/yyyy"
                            minDate={new Date()}
                            className="form-control"
                            disabled={submitLoading || stopLoading}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="endTime">End Time</label>
                        <select
                            id="endTime"
                            value={formatTimeWithAMPM(formData.endTime)} // Format as 12-hour with AM/PM
                            onChange={(e) => {
                                // Find the corresponding time value from the options
                                const selectedOption = timeOptions.find(option => option.label === e.target.value);
                                if (selectedOption) {
                                    handleChange('endTime', selectedOption.value);
                                }
                            }}
                            className="form-control"
                            disabled={submitLoading || stopLoading}
                        >
                            {timeOptions.map(option => (
                                <option key={option.label}
                                        value={option.label}>{option.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/*<div className="form-actions">*/}
                {/*    <button*/}
                {/*        className="btn-submit"*/}
                {/*        onClick={() => handleSubmit('start')}*/}
                {/*        disabled={isSubmitting}*/}
                {/*    >*/}
                {/*        {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}*/}
                {/*    </button>*/}
                {/*    <button*/}
                {/*        className="btn-force-stop"*/}
                {/*        onClick={() => handleSubmit('stop')}*/}
                {/*        disabled={isSubmitting}*/}
                {/*    >*/}
                {/*        {isSubmitting ? 'STOPPING...' : 'FORCE STOP'}*/}
                {/*    </button>*/}
                {/*</div>*/}
                <div className="form-actions">
                  <button
                    className="btn-submit"
                    onClick={() => handleSubmit('start')}
                    disabled={submitLoading || stopLoading}
                  >
                    {submitLoading ? 'SUBMITTING...' : 'SUBMIT'}
                  </button>
                  <button
                    className="btn-force-stop"
                    onClick={() => handleSubmit('stop')}
                    disabled={submitLoading || stopLoading}
                  >
                    {stopLoading ? 'STOPPING...' : 'FORCE STOP'}
                  </button>
                </div>
            </div>
        </div>
    );
};

export default EnvironmentControl;